import React from 'react';
import { ZapIcon, TwitterIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0F0F1A] border-t border-white/5 py-12 px-6" data-id="element-45">
      <div className="max-w-6xl mx-auto" data-id="element-46">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-8 mb-10" data-id="element-47">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-48">
            <ZapIcon className="w-5 h-5 text-[#4361EE]" data-id="element-49" />
            <span className="text-[#4361EE] text-2xl tracking-widest" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.15em'
          }} data-id="element-50">
              ADHD RESET
            </span>
          </div>

          {/* Social links */}
          <div className="flex items-center gap-4" data-id="element-51">
            <a href="#" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-[#A0AEC0] hover:text-white hover:border-[#4361EE] transition-all duration-200" aria-label="Twitter" data-id="element-52">
              <TwitterIcon className="w-4 h-4" data-id="element-53" />
            </a>
            <a href="#" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-[#A0AEC0] hover:text-white hover:border-[#4361EE] transition-all duration-200" aria-label="Instagram" data-id="element-54">
              <InstagramIcon className="w-4 h-4" data-id="element-55" />
            </a>
            <a href="#" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-[#A0AEC0] hover:text-white hover:border-[#4361EE] transition-all duration-200" aria-label="YouTube" data-id="element-56">
              <YoutubeIcon className="w-4 h-4" data-id="element-57" />
            </a>
          </div>
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-58">
          {['Privacy Policy', 'Terms of Service', 'Refund Policy', 'Contact Us', 'Affiliates'].map(link => <a key={link} href="#" className="text-[#A0AEC0] hover:text-white text-sm transition-colors" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-59">
              {link}
            </a>)}
        </div>

        {/* Disclaimer */}
        <div className="border-t border-white/5 pt-8 text-center" data-id="element-60">
          <p className="text-[#A0AEC0] text-xs leading-relaxed max-w-2xl mx-auto mb-4" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-61">
            Results mentioned are not typical. Individual results will vary
            based on effort, experience, and other factors. ADHD Reset is an
            educational product and is not a substitute for professional medical
            advice, diagnosis, or treatment.
          </p>
          <p className="text-[#A0AEC0]/50 text-xs" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-62">
            © {new Date().getFullYear()} ADHD Reset. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}